// src/utils/auth.js
export const setSession = (token, currentLocation = window.location) => {
  // Use sessionStorage for tab-specific persistence
  sessionStorage.setItem('token', token);
  
  // Set a session cookie (expires when browser closes)
  document.cookie = `session_token=${token}; Path=/; SameSite=Strict${
    currentLocation.protocol === 'https:' ? '; Secure' : ''
  }`;
};

// export const clearSession = () => {
//   // Clear sessionStorage
//   sessionStorage.removeItem('token');
  
//   // Clear cookie by setting expired date
//   document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict' + 
//     (window.location.protocol === 'https:' ? '; Secure' : '');
// };

export const getToken = () => {
  const match = document.cookie.match(/session_token=([^;]+)/);
  return match ? match[1] : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const clearSession = () => {
  document.cookie = 'session_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Strict' + 
    (window.location.protocol === 'https:' ? '; Secure' : '');
};

